var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 0.583252C10.8502 0.583252 0.583496 10.8499 0.583496 23.4999C0.583496 36.1499 10.8502 46.4166 23.5002 46.4166C36.1502 46.4166 46.4168 36.1499 46.4168 23.4999C46.4168 10.8499 36.1502 0.583252 23.5002 0.583252ZM23.5002 7.45825C27.3043 7.45825 30.3752 10.5291 30.3752 14.3333C30.3752 18.1374 27.3043 21.2083 23.5002 21.2083C19.696 21.2083 16.6252 18.1374 16.6252 14.3333C16.6252 10.5291 19.696 7.45825 23.5002 7.45825ZM23.5002 39.9999C17.771 39.9999 12.7064 37.0666 9.75016 32.6208C9.81891 28.0603 18.9168 25.5624 23.5002 25.5624C28.0606 25.5624 37.1814 28.0603 37.2502 32.6208C34.2939 37.0666 29.2293 39.9999 23.5002 39.9999Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b0cfab584116bae842d9f5b11889c6b9.svg";
export { ForwardRef as ReactComponent };